"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsReadinessCharts = void 0;
var react_1 = __importStar(require("react"));
require("./ReadlinessCharts.scss");
var joinClassNames = function () {
    var names = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        names[_i] = arguments[_i];
    }
    return names.filter(Boolean).join(' ');
};
var clampPercentage = function (value) {
    if (value < 0) {
        return 0;
    }
    if (value > 100) {
        return 100;
    }
    return value;
};
var buildStats = function (items) {
    var totalCount = items.length;
    var readyCount = items.filter(function (item) { return item.isReady; }).length;
    var rawPercentage = totalCount > 0 ? (readyCount / totalCount) * 100 : 0;
    var percentage = clampPercentage(rawPercentage);
    if (percentage >= 70) {
        return { readyCount: readyCount, totalCount: totalCount, percentage: percentage, level: 'high' };
    }
    if (percentage >= 40) {
        return { readyCount: readyCount, totalCount: totalCount, percentage: percentage, level: 'medium' };
    }
    return { readyCount: readyCount, totalCount: totalCount, percentage: percentage, level: 'low' };
};
var sortByReadiness = function (items) {
    return __spreadArrays(items).sort(function (left, right) {
        if (left.isReady === right.isReady) {
            return left.label.localeCompare(right.label);
        }
        return left.isReady ? -1 : 1;
    });
};
var formatReadinessScore = function (score) {
    if (typeof score !== 'number' || Number.isNaN(score)) {
        return 'N/A';
    }
    var rounded = Math.max(0, Math.min(100, Math.round(score * 100) / 100));
    var displayValue = Number.isInteger(rounded)
        ? "" + rounded
        : rounded
            .toFixed(2)
            .replace(/\.0+$/, '')
            .replace(/(\.\d*[1-9])0+$/, '$1');
    return displayValue + "%";
};
var ReadinessCard = function (_a) {
    var title = _a.title, items = _a.items, isExpanded = _a.isExpanded, onToggleExpand = _a.onToggleExpand, highlightText = _a.highlightText, keyPrefix = _a.keyPrefix;
    var stats = react_1.useMemo(function () { return buildStats(items); }, [items]);
    var sortedItems = react_1.useMemo(function () { return sortByReadiness(items); }, [items]);
    var progressLabel = stats.readyCount + "/" + stats.totalCount + " ready";
    return (react_1.default.createElement("article", { className: "ws-ai-hub-readiness-card" },
        react_1.default.createElement("h3", { className: "ws-ai-hub-readiness-card-title" },
            react_1.default.createElement("span", null, title),
            react_1.default.createElement("span", { className: "ws-ai-hub-readiness-progress-label" }, highlightText ? highlightText(progressLabel, keyPrefix + "-summary") : progressLabel)),
        react_1.default.createElement("div", { className: "ws-ai-hub-readiness-progress", role: "progressbar", "aria-valuemin": 0, "aria-valuemax": stats.totalCount || 1, "aria-valuenow": stats.readyCount, "aria-label": title + " readiness" },
            react_1.default.createElement("div", { className: joinClassNames('ws-ai-hub-readiness-progress-fill', "ws-ai-hub-readiness-progress-fill-" + stats.level), style: { width: stats.percentage + "%" } })),
        react_1.default.createElement("button", { type: "button", className: "ws-ai-hub-readiness-toggle", onClick: onToggleExpand, "aria-expanded": isExpanded }, isExpanded ? 'Show less' : 'Show more'),
        isExpanded ? (react_1.default.createElement("ul", { className: "ws-ai-hub-readiness-list" }, sortedItems.map(function (item, index) { return (react_1.default.createElement("li", { key: item.id || keyPrefix + "-" + item.label + "-" + index, className: "ws-ai-hub-readiness-list-item" },
            react_1.default.createElement("span", { className: joinClassNames('ws-ai-hub-readiness-list-status', item.isReady && 'ws-ai-hub-readiness-list-status-ready'), "aria-hidden": "true" }, item.isReady ? '✓' : ''),
            react_1.default.createElement("span", { className: "ws-ai-hub-readiness-list-label" }, highlightText
                ? highlightText(item.label, keyPrefix + "-item-" + (index + 1))
                : item.label))); }))) : null));
};
var WsReadinessCharts = function (_a) {
    var technologyItems = _a.technologyItems, dataSourceItems = _a.dataSourceItems, readinessTotalScore = _a.readinessTotalScore, className = _a.className, highlightText = _a.highlightText;
    var _b = react_1.useState(false), isTechnologyExpanded = _b[0], setIsTechnologyExpanded = _b[1];
    var _c = react_1.useState(false), isDataSourceExpanded = _c[0], setIsDataSourceExpanded = _c[1];
    var totalScoreLabel = formatReadinessScore(readinessTotalScore);
    return (react_1.default.createElement("section", { className: joinClassNames('ws-ai-hub-readiness-charts', className) },
        react_1.default.createElement("h2", { className: "ws-ai-hub-prioritisation-title" }, "Readiness"),
        react_1.default.createElement("div", { className: "ws-ai-hub-readiness-charts-summary" },
            "Use Case readiness total score: ",
            react_1.default.createElement("strong", null, totalScoreLabel)),
        react_1.default.createElement("div", { className: "ws-ai-hub-readiness-charts-grid" },
            react_1.default.createElement(ReadinessCard, { title: "Technology Readiness", items: technologyItems, isExpanded: isTechnologyExpanded, onToggleExpand: function () { return setIsTechnologyExpanded(function (value) { return !value; }); }, highlightText: highlightText, keyPrefix: "technology-readiness" }),
            react_1.default.createElement(ReadinessCard, { title: "Data Source Readiness", items: dataSourceItems, isExpanded: isDataSourceExpanded, onToggleExpand: function () { return setIsDataSourceExpanded(function (value) { return !value; }); }, highlightText: highlightText, keyPrefix: "data-source-readiness" }))));
};
exports.WsReadinessCharts = WsReadinessCharts;
